"use client";

const LINES = 5;

export function FakeDataWatermark() {
  return (
    <div
      className="absolute inset-0 overflow-hidden pointer-events-none select-none"
      aria-hidden="true"
    >
      {Array.from({ length: LINES }, (_, i) => (
        <div
          key={i}
          className="absolute whitespace-nowrap text-[13px] sm:text-[15px] font-bold tracking-wider text-white/[0.07]"
          style={{
            top: `${12 + i * 22}%`,
            left: "-5%",
            right: "-5%",
            transform: "rotate(-18deg)",
            transformOrigin: "center center",
          }}
        >
          {Array.from({ length: 4 }, (_, j) => (
            // The text lives in a pseudo-element, not the DOM: as a text
            // node it was indexed by Google on every game page carrying a
            // locked block, and could surface in a result snippet.
            <span
              key={j}
              className="mx-6 before:content-[attr(data-w)]"
              data-w="THIS IS FAKE DATA — Nice try though ;)"
            />
          ))}
        </div>
      ))}
    </div>
  );
}
